import dayjs from '$/utils/dayjs';

const TIME_PATTERN = /[T ]\d{2}:\d{2}/;

// A booking's dateTime/end may be a plain date ("2027-01-14") for records
// saved before the arrival/departure time became a required field — this
// must keep rendering as a date-only value, never "Invalid Date" or a
// fabricated 00:00 time.
export const formatBookingMoment = (value: string): string => {
  const parsed = dayjs(value);

  if (!parsed.isValid()) return value;

  return TIME_PATTERN.test(value) ? parsed.format('DD/MM/YY HH:mm') : parsed.format('DD/MM/YY');
};

export const formatBookingWhen = (dateTime?: string, end?: string): string | null => {
  if (!dateTime?.trim()) return null;

  const start = formatBookingMoment(dateTime.trim());

  return end?.trim() ? `${start} – ${formatBookingMoment(end.trim())}` : start;
};
